/** PC 管理端菜单权限（与后端 menu: 前缀一致） */

export function isAdminSuper() {
  const v = localStorage.getItem("admin_is_super");
  if (v === null && localStorage.getItem("admin_token")) {
    return true; // 兼容升级前已登录会话
  }
  return v === "1" || v === "true";
}

export function getAdminPermissions() {
  if (isAdminSuper()) return ["*"];
  try {
    const raw = localStorage.getItem("admin_permissions");
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function setAdminAuthExtras(user) {
  if (!user) return;
  localStorage.setItem("admin_is_super", user.isSuper ? "1" : "0");
  localStorage.setItem(
    "admin_permissions",
    JSON.stringify(user.permissions || (user.isSuper ? ["*"] : []))
  );
}

export function clearAdminAuthExtras() {
  localStorage.removeItem("admin_is_super");
  localStorage.removeItem("admin_permissions");
}

export function menuRouteVisible(routeKey, perms) {
  if (!perms || perms.includes("*")) return true;
  const menuKey = `menu:${routeKey}`;
  for (const p of perms) {
    if (p === menuKey || p.startsWith(`${menuKey}/`)) return true;
  }
  // 主表查询与 wifi 电表测试同属测试工具，沿用 wifi 测试菜单权限
  if (routeKey === "/test/by-gateway-bind" && perms.includes("menu:/test/wifi-meter")) {
    return true;
  }
  if (
    routeKey === "/test/by-recharge-order-query" &&
    (perms.includes("menu:/test/wifi-meter") || perms.includes("menu:/test/by-gateway-bind"))
  ) {
    return true;
  }
  if (routeKey === "/test/main-meter-lookup" && perms.includes("menu:/test/wifi-meter")) {
    return true;
  }
  if (routeKey === "/test/heartbeat-raw-query" && perms.includes("menu:/test/wifi-meter")) {
    return true;
  }
  if (routeKey === "/test/yj-electrical-query" && perms.includes("menu:/test/wifi-meter")) {
    return true;
  }
  if (routeKey === "/test/fangdong-scope-compare" && perms.includes("menu:/test/wifi-meter")) {
    return true;
  }
  if (routeKey === "/test/voice-notify-day-query" && (perms.includes("menu:/test/wifi-meter") || perms.includes("menu:/test/exclusive-pool-voice"))) {
    return true;
  }
  if (routeKey === "/test/huifu-order-query" && (perms.includes("menu:/huifu/tools") || perms.includes("menu:/test/wifi-meter"))) {
    return true;
  }
  // 房东余额一键查询：复用汇付工具/账号权限（纯前端串行调已有接口）
  if (
    routeKey === "/huifu/landlord-balance" &&
    (perms.includes("menu:/huifu") ||
      perms.includes("menu:/huifu/tools") ||
      perms.includes("menu:/huifu/account") ||
      perms.includes("menu:/huifu/bank-card"))
  ) {
    return true;
  }
  if (routeKey === "/test/bluetooth-public-pool-voice" && perms.includes("menu:/test/public-pool-voice")) {
    return true;
  }
  if (routeKey === "/test/bluetooth-exclusive-pool-voice" && perms.includes("menu:/test/exclusive-pool-voice")) {
    return true;
  }
  if (routeKey === "/test/bluetooth-low-balance-notify-preview" && perms.includes("menu:/test/exclusive-pool-voice")) {
    return true;
  }
  if (
    (routeKey === "/test/remote-low-balance-sms" || routeKey === "/test/bluetooth-low-balance-sms") &&
    (perms.includes("menu:/test/wifi-meter") ||
      perms.includes("menu:/test/public-pool-voice") ||
      perms.includes("menu:/test/exclusive-pool-voice"))
  ) {
    return true;
  }
  return false;
}

export function filterMenuItems(items, perms) {
  if (!perms || perms.includes("*")) return items;
  return items
    .map((item) => {
      if (item.superOnly && !isAdminSuper()) return null;
      if (item.children) {
        const children = item.children.filter((c) => menuRouteVisible(c.key, perms));
        if (children.length > 0) return { ...item, children };
        if (menuRouteVisible(item.key, perms)) return { ...item, children: item.children };
        return null;
      }
      return menuRouteVisible(item.key, perms) ? item : null;
    })
    .filter(Boolean);
}

/** 登录后默认跳转：取第一个有权限的叶子菜单 */
export function firstAllowedRoute(perms) {
  const all = [
    "/",
    "/todo/list",
    "/user/list",
    "/house/house",
    "/house/room",
    "/house/room-stats",
    "/house/person-split",
    "/house/qrcode",
    "/house/bill",
    "/device/electric",
    "/device/water",
    "/device/lock",
    "/operation-log/electric",
    "/operation-log/water",
    "/operation-log/lock",
    "/order/list",
    "/split/config",
    "/huifu/account",
    "/huifu/bank-card",
    "/huifu/tools",
    "/huifu/landlord-balance",
    "/huifu/withdraw-records",
    "/system/roles/list",
    "/system/change-password",
    "/system/base",
    "/system/security",
    "/system/columns",
    "/test/wifi-meter",
    "/test/main-meter-lookup",
    "/test/heartbeat-raw-query",
    "/test/yj-electrical-query",
    "/test/fangdong-scope-compare",
    "/test/voice-notify-day-query",
    "/test/huifu-order-query",
  ];
  for (const key of all) {
    if (menuRouteVisible(key, perms)) return key;
  }
  return "/test/wifi-meter";
}
